// @ts-nocheck
import * as React from "react";

const ThinArrowRight: React.FC = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 9H14.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 3.75L14.25 9L9 14.25" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default React.memo(ThinArrowRight);
